/* eslint-disable */
/**
 * Select the `locales`
 * @param {any} state The state management `state`
 * @returns {Array<I18nEntityLocale>} The current `locales`
 */
const i18nLocalesSelector = (state) => state.i18n.locales;

export default i18nLocalesSelector;
